// Keys used to store stuff to session/local storage

export const storageKeys = {
  STOCK_DISPLAY_MODE: 'STOCK_DISPLAY_MODE',
  SELECTED_LOCATION_ID: 'SELECTED_LOCATION_ID',
  UCC_NEWS_ITEM: 'UCC_NEWS_ITEM',
  UCC_PREFERRED_LANGUAGE: 'UCC_PREFERRED_LANGUAGE',
}
